import z from "zod";

import {
  TESTOSTERONE_STEP_ACTION_TYPES,
  TESTOSTERONE_STEP_STATUS,
  TESTOSTERONE_STEP_TYPES,
} from "./enums";

const TestosteroneStepAction = z.object({
  type: z.enum(TESTOSTERONE_STEP_ACTION_TYPES),
  url: z.string(),
  isExternal: z.boolean(),
});
export type TestosteroneStepAction = z.infer<typeof TestosteroneStepAction>;

export const TestosteroneStep = z.object({
  type: z.enum(TESTOSTERONE_STEP_TYPES),
  subtitle: z.string().optional(),
  status: z.enum(TESTOSTERONE_STEP_STATUS),
  actions: z.array(TestosteroneStepAction).optional(),
});
export type TestosteroneStep = z.infer<typeof TestosteroneStep>;
